import { SPACING_TOKENS } from '../../constants/tokens.mjs';
import { PopoverCssProperty } from '../../types/style.mjs';
import { customStrategy } from '../customStrategy/customStrategy.mjs';

({
  maxWidth: `var(--osui_width-sidebar-desktop)`,
  maxHeight: `calc(100vh - ${SPACING_TOKENS['space-2']} - var(${PopoverCssProperty.Top}))`
});
function preferCenteredBelowStrategy({
  options,
  measurements
}) {
  return customStrategy({
    options: {
      ...options,
      position: 'below',
      alignment: 'center'
    },
    measurements
  });
}

export { preferCenteredBelowStrategy };
